import { render, staticRenderFns } from "./KeptItemsUnavailableNotice.vue?vue&type=template&id=0fd4ce87&"
import script from "./KeptItemsUnavailableNotice.vue?vue&type=script&lang=js&"
export * from "./KeptItemsUnavailableNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd4ce87')) {
      api.createRecord('0fd4ce87', component.options)
    } else {
      api.reload('0fd4ce87', component.options)
    }
    module.hot.accept("./KeptItemsUnavailableNotice.vue?vue&type=template&id=0fd4ce87&", function () {
      api.rerender('0fd4ce87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/KeptItemsUnavailableNotice.vue"
export default component.exports